import React, { useState, useEffect } from 'react';
import { bool, func, object, string, number } from 'prop-types';
import classNames from 'classnames';

import { ACCOUNT_SETTINGS_PAGES } from '../../../../routing/routeConfiguration';
import { propTypes } from '../../../../util/types';
import {
  Avatar,
  InlineTextButton,
  LinkedLogo,
  Menu,
  MenuLabel,
  MenuContent,
  MenuItem,
  NamedLink,
} from '../../../../components';

import SearchIcon from '../images/search-icon.svg';
import NotificationsIcon from '../images/notifications-icon.svg';
import css from './TopbarDesktop.module.css';
import { getHasProfileListing, getIsMentor } from '../../../../util/userUtil';
import { getEditProfileListingLinkProperties } from '../../../../util/listingUtil';

const TopbarDesktop = ({
  rootClassName = null,
  className = null,
  currentUser = null,
  currentPage = null,
  appConfig = null,
  isAuthenticated,
  onLogout,
  currentUserProfileListing,
  title,
  notificationCount,
}) => {
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  const marketplaceName = appConfig.marketplaceName;
  const authenticatedOnClientSide = mounted && isAuthenticated;

  const classes = classNames(rootClassName || css.root, className);

  const titleMaybe = title ? <p className={css.title}>{title}</p> : null;

  // const inboxLink = authenticatedOnClientSide ? (
  //   <NamedLink
  //     className={css.inboxLink}
  //     name="InboxPage"
  //     params={{ tab: currentUserHasListings ? 'sales' : 'orders' }}
  //   >
  //     <span className={css.inbox}>
  //       <FormattedMessage id="TopbarDesktop.inbox" />
  //       {notificationDot}
  //     </span>
  //   </NamedLink>
  // ) : null;

  const currentPageClass = page => {
    const isAccountSettingsPage =
      page === 'AccountSettingsPage' && ACCOUNT_SETTINGS_PAGES.includes(currentPage);
    return currentPage === page || isAccountSettingsPage ? css.currentPage : null;
  };

  const profileMenu = getIsMentor(currentUser) ? (
    <Menu>
      <MenuLabel className={css.profileMenuLabel} isOpenClassName={css.profileMenuIsOpen}>
        <Avatar className={css.avatar} user={currentUser} disableProfileLink />
      </MenuLabel>
      <MenuContent className={css.profileMenuContent}>
        <MenuItem key="ManageListingsPage">
          <NamedLink
            className={classNames(css.yourListingsLink, currentPageClass('ManageListingsPage'))}
            name="ManageListingsPage"
          >
            <span className={css.menuItemBorder} />
            Your mentor profile
          </NamedLink>
        </MenuItem>
        <MenuItem key="AccountSettingsPage">
          <NamedLink
            className={classNames(css.yourListingsLink, currentPageClass('AccountSettingsPage'))}
            name="AccountSettingsPage"
          >
            <span className={css.menuItemBorder} />
            Account settings
          </NamedLink>
        </MenuItem>
        {/* <MenuItem key="MasterCalendarPage">
          <NamedLink
            className={classNames(css.profileSettingsLink, currentPageClass('MasterCalendarPage'))}
            name="MasterCalendarPage"
          >
            <span className={css.menuItemBorder} />
            Your calendar
          </NamedLink>
        </MenuItem> */}
        <MenuItem key="logout">
          <InlineTextButton rootClassName={css.logoutButton} onClick={onLogout}>
            <span className={css.menuItemBorder} />
            Log out
          </InlineTextButton>
        </MenuItem>
      </MenuContent>
    </Menu>
  ) : (
    <Menu>
      <MenuLabel className={css.profileMenuLabel} isOpenClassName={css.profileMenuIsOpen}>
        <Avatar className={css.avatar} user={currentUser} disableProfileLink />
      </MenuLabel>
      <MenuContent className={css.profileMenuContent}>
        <MenuItem key="AccountSettingsPage">
          <NamedLink
            className={classNames(css.yourListingsLink, currentPageClass('AccountSettingsPage'))}
            name="AccountSettingsPage"
          >
            <span className={css.menuItemBorder} />
            Account settings
          </NamedLink>
        </MenuItem>
        {/* <MenuItem key="MasterCalendarPage">
          <NamedLink
            className={classNames(css.profileSettingsLink, currentPageClass('MasterCalendarPage'))}
            name="MasterCalendarPage"
          >
            <span className={css.menuItemBorder} />
            Your calendar
          </NamedLink>
        </MenuItem> */}
        <MenuItem key="logout">
          <InlineTextButton rootClassName={css.logoutButton} onClick={onLogout}>
            <span className={css.menuItemBorder} />
            Log out
          </InlineTextButton>
        </MenuItem>
      </MenuContent>
    </Menu>
  );

  // const signupLink = isAuthenticatedOrJustHydrated ? null : (
  //   <NamedLink name="SignupPage" className={css.signupLink}>
  //     <span className={css.signup}>
  //       Sign up
  //     </span>
  //   </NamedLink>
  // );

  // const loginLink = isAuthenticatedOrJustHydrated ? null : (
  //   <NamedLink name="LoginPage" className={css.loginLink}>
  //     <span className={css.login}>
  //       Log in
  //     </span>
  //   </NamedLink>
  // );

  return (
    <nav className={classes}>
      <LinkedLogo
        className={css.logoLink}
        rootClassName={css.logo}
        layout="desktop"
        alt={marketplaceName}
      />

      {titleMaybe}
      {/* {search} */}

      {/* {currentUserHasListings ? null : (<NamedLink className={css.createListingLink} name="NewListingPage">
        <span className={css.createListing}>
          Create your mentor profile
        </span>
      </NamedLink>)} */}

      {/* {renderBeforeInbox && renderBeforeInbox()} */}

      {/* {inboxLink} */}

      <div className="row">
        {authenticatedOnClientSide ? (
          // Authenticated user content
          <>
            {getIsMentor(currentUser) && !getHasProfileListing(currentUser) && (
              <NamedLink className={css.createListingLink} name="NewListingPage">
                <span className={css.createListing}>Create mentor profile</span>
              </NamedLink>
            )}

            {getIsMentor(currentUser) && getHasProfileListing(currentUser) && (
              <NamedLink
                className={css.createListingLink}
                {...getEditProfileListingLinkProperties(currentUserProfileListing)}
              >
                <span className={css.createListing}>Edit profile</span>
              </NamedLink>
            )}

            <NamedLink className={css.inboxLink} name="SearchPage">
              <img className={css.icon} src={SearchIcon} alt="Search" />
            </NamedLink>

            <NamedLink
              className={css.inboxLink}
              name="InboxPage"
              params={{ tab: getIsMentor(currentUser) ? 'sales' : 'orders' }}
            >
              <span style={{ position: 'relative', display: 'inline-block' }}>
                <img className={css.icon} src={NotificationsIcon} alt="Notifications" />
                {notificationCount > 0 ? <span className={css.notificationDot} /> : null}
              </span>
            </NamedLink>

            {profileMenu}
          </>
        ) : (
          // Unauthenticated user content
          <div className={css.authButtons}>
            <NamedLink name="LoginPage" className={css.authLink + '?from=%2Fdashboard'}>
              <span className={css.authButton}>Log in</span>
            </NamedLink>
            <NamedLink name="SignupPage" className={css.authLink + '?from=%2Fdashboard'}>
              <span className={css.authButtonPrimary}>Sign up</span>
            </NamedLink>
          </div>
        )}
      </div>
      {/* {signupLink} */}
      {/* {loginLink} */}
    </nav>
  );
};



TopbarDesktop.propTypes = {
  rootClassName: string,
  className: string,
  currentUser: propTypes.currentUser,
  currentPage: string,
  isAuthenticated: bool.isRequired,
  onLogout: func.isRequired,
  appConfig: object,
  notificationCount: number,
};

export default TopbarDesktop;
